<div class="row billet-wks-inputs align-items-start h-100 with-bg">
  <div class="col-12 billet h-100" *ngIf="!showConfirmationBillit"
    [ngClass]="{'with-bg': withBackground, 'isBilletFloat': isBilletFloat}">
    <div class="row scroll-body" [ngClass]="{'theory': auctionHammer, 'max-height-float': isBilletFloat}">
      <div class="{{ 'col-' + configInput[14].col }} {{ configInput[14].class }}"
        [ngClass]="{'col-12': strategyOptions?.length <= 1}"
        *ngIf="configInput[14]?.active && typeOrderOptions?.length > 1">
        <mat-form-field>
          <mat-select panelClass="buy-sell-options" [(ngModel)]="model.type" placeholder="{{ configInput[14].desc }}"
            (selectionChange)="configsInputTypeOrder(model.type)" name="nameTypeOrder"
            [disabled]="typeOrderOptions?.length <= 0" id="select-type-order">
            <mat-option *ngFor="let item of typeOrderOptions" [value]="item.webFeeder">{{item.desc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="{{ 'col-' + configInput[1].col }} {{ configInput[1].class }}"
        *ngIf="configInput[1]?.active && strategyOptions?.length > 1">
        <mat-form-field>
          <mat-select [(ngModel)]="model.orderStrategy" placeholder="{{ configInput[1].desc }}"
            panelClass="buy-sell-options">
            <mat-option *ngFor="let strategy of strategyOptions" [value]="strategy.orderStrategy">
              {{ strategy.orderStrategy }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="{{ 'col-' + configInput[0].col }} {{ configInput[0].class }}" *ngIf="configInput[0].active">
        <mat-form-field>
          <mat-select placeholder="{{ configInput[0].desc }}" [(ngModel)]="model.type" panelClass="buy-sell-options">
            <mat-option *ngFor="let type of typesOptions" (onSelectionChange)="verifyPrice()" [value]="type.id">
              {{ type.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="{{ model.type === 'Market' ? 'col-12' : 'col-' + configInput[4].col }} {{ configInput[4].class }}"
        *ngIf="configInput[4].active">
        <app-incremental-input name="model.qtd" ondragstart="return false;" ondrop="return false;"
          placeholder="{{ configInput[4].desc }}" [roundLot]="model.loteDefault" [maxlength]="7"
          (mousewheel)="verifyQuantity()" [invalid]="qtdValid" minValue="0" maxValue="999999"
          (keydown)="validPrice(model.qtd)" (keyup)="verifyQuantity();validPrice(model.qtd);" (click)="verifyQuantity()"
          [isQuantity]="true" [(ngModel)]="model.qtd" aria-required="" [isDisabled]="!quantityDisabled()">
        </app-incremental-input>
        <!-- <div class="invalidQtd" *ngIf="!qtdValid">A quantidade deve ser maior que zero.</div> -->
      </div>
      <div class="{{ 'col-' + configInput[5].col }} {{ configInput[5].class }}"
        *ngIf="configInput[5].active && model.type !== 'Market'">
        <app-incremental-input name="model.price" ondragstart="return false;" ondrop="return false;" id="preço"
          placeholder="{{ configInput[5].desc }}" (valueChanged)="validPrice(model.price);verifyQuantity()"
          [options]="indiceFuture ? priceValuesFormatOptionsFuture : priceValuesFormatOptions"
          [roundLot]="this.minimumIncrement" minValue="0" maxValue="999999" [isQuantity]="true" [price]="true"
          [(ngModel)]="model.price" aria-required="" [isDisabled]="!verifyPrice()" (keyup)="verifyQuantity()"
          [minValue]="0" (keyup)="validPrice(model.price)">
        </app-incremental-input>
      </div>
      <div class="{{ 'col-' + configInput[2].col }} {{ configInput[2].class }}" *ngIf="configInput[2].active">
        <mat-form-field>
          <mat-select (openedChange)="setSelectYPosition($event)" [(ngModel)]="model.timeInForce"
            placeholder="{{ configInput[2].desc }}" panelClass="buy-sell-options">
            <mat-option *ngFor="let date of timeInForceOptions" (onSelectionChange)="resetDate()"
              [value]="date?.webfeeder">
              {{ date?.desc }}
            </mat-option>
          </mat-select>
          <div class="invalid" *ngIf="!model.timeInForce">Campo <strong>obrigatório</strong>.</div>
        </mat-form-field>
      </div>
      <div class="{{ 'col-' + configInput[3].col }} {{ configInput[3].class }}" *ngIf="configInput[3].active">
        <mat-form-field class="date" [ngClass]="{'m-date': model.type === 'Stop'}">
          <input appDatepickerMask matInput [matDatepicker]="picker2" [min]="minDate"
            placeholder="{{ configInput[3].desc }}" [(ngModel)]="model.validityOrder"
            [disabled]="model.timeInForce != 'GTD'">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 bg-invert m-btn-5" *ngIf="configInput[6].active">
        <div class="row">
          <div class="{{ 'col-' + configInput[6].col }} {{ configInput[6].class }}" *ngIf="configInput[6].active">
            <div class="row">
              <div class="col-9">
                <span class="option-font option-font-title">{{ configInput[6].desc }}
                  <mat-icon class="icon" svgIcon="info-billet" matTooltipPosition="above"
                    matTooltip="{{messageStopLoss}}" matTooltipClass="billetTooltip"></mat-icon>
                </span>
              </div>
              <div class="col-3 align-r">
                <mat-slide-toggle id="toggle-theme" class="toggle-theme small" [(ngModel)]="stopLoss"
                  (change)="setStopLoss(!model.stopLoss);tooltipValidator()">
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="{{ 'col-' + configInput[7].col }} {{ configInput[7].class }}" id="stop-loss-content-wks"
            *ngIf="configInput[7].active && stopLoss">
            <app-incremental-input [placeholder]="configInput[7].desc"
              [options]="indiceFuture? priceValuesFormatOptionsFuture : priceValuesFormatOptions"
              [roundLot]="+this.minimumIncrement" (valueChanged)="tooltipValidator()" [maxlength]="13"
              [invalid]="lossTrigger" minValue="0" maxValue="999999" [isQuantity]="true" [(ngModel)]="model.stoptrigger"
              aria-required="" [isDisabled]="!model.stopLoss" [required]="model.stopLoss" [price]="true"
              (keyup)="verifyQuantity();validPrice(model.stoptrigger);" ondragstart="return false;"
              ondrop="return false;">
            </app-incremental-input>
            <!-- <div class="invalidQtd" *ngIf="!lossTrigger">Valor inválido.</div> -->
          </div>
          <div class="{{ 'col-' + configInput[8].col }} {{ configInput[8].class }}" id="stop-loss-content-wks"
            *ngIf="configInput[8].active && stopLoss">
            <app-incremental-input [placeholder]="configInput[8].desc"
              [options]="indiceFuture?priceValuesFormatOptionsFuture : priceValuesFormatOptions"
              [roundLot]="+this.minimumIncrement" (valueChanged)="tooltipValidator()" [maxlength]="13"
              [invalid]="lossLimit" minValue="0" maxValue="999999" [isQuantity]="true" [(ngModel)]="model.stoplimit"
              aria-required="" [isDisabled]="!model.stopLoss" [price]="true"
              (keyup)="verifyQuantity();validPrice(model.stoplimit);" ondragstart="return false;"
              ondrop="return false;">
            </app-incremental-input>
            <!-- <div class="invalidQtd" *ngIf="!lossLimit">Valor inválido.</div> -->
          </div>
        </div>
      </div>
      <div class="col-12 bg-invert m-btn-5" *ngIf="configInput[9].active">
        <div class="row">
          <div class="{{ 'col-' + configInput[9].col }} {{ configInput[9].class }}" *ngIf="configInput[9].active">
            <div class="row">
              <div class="col-9">
                <span class="option-font option-font-title">{{ configInput[9].desc }}
                  <mat-icon class="icon" svgIcon="info-billet" matTooltipPosition="above"
                    matTooltip="{{messageStopGain}}" matTooltipClass="billetTooltip"></mat-icon>
                </span>
              </div>
              <div class="col-3 align-r">
                <mat-slide-toggle id="toggle-theme" class="toggle-theme small" [(ngModel)]="stopGain"
                  (change)="setStopGain(!model.stopGain);tooltipValidator()">
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="{{ 'col-' + configInput[10].col }} {{ configInput[10].class }}" id="stop-gain-content-wks"
            *ngIf="configInput[10].active && stopGain">
            <app-incremental-input [placeholder]="configInput[10].desc"
              [options]="indiceFuture ? priceValuesFormatOptionsFuture : priceValuesFormatOptions"
              [roundLot]="+this.minimumIncrement" (valueChanged)="tooltipValidator()" [maxlength]="13"
              [invalid]="gainTrigger" minValue="0" maxValue="999999" [isQuantity]="true"
              [(ngModel)]="model.targettrigger" aria-required="" [isDisabled]="!model.stopGain" [price]="true"
              (keyup)="verifyQuantity();validPrice(model.targettrigger);" ondragstart="return false;"
              ondrop="return false;"></app-incremental-input>
            <!-- <div class="invalidQtd" *ngIf="!gainTrigger">Valor inválido.</div> -->
          </div>
          <div class="{{ 'col-' + configInput[11].col }} {{ configInput[11].class }}" id="stop-gain-content-wks"
            *ngIf="configInput[11].active && stopGain">
            <app-incremental-input [placeholder]="configInput[11].desc"
              [options]="indiceFuture ?priceValuesFormatOptionsFuture : priceValuesFormatOptions"
              [roundLot]="+this.minimumIncrement" (valueChanged)="tooltipValidator()" [maxlength]="13" minValue="0"
              maxValue="999999" [isQuantity]="true" ondragstart="return false;" ondrop="return false;"
              [(ngModel)]="model.targetlimit" [invalid]="gainLimit" aria-required="" [isDisabled]="!model.stopGain"
              [price]="true" (keyup)="verifyQuantity();validPrice(model.targetlimit);">
            </app-incremental-input>
            <!-- <div class="invalidQtd" *ngIf="!gainLimit">Valor inválido.</div> -->
          </div>
        </div>
      </div>
      <div class="{{ 'col-' + configInput[15].col }} {{ configInput[15].class }}" *ngIf="configInput[15].active">
        <div class="row">
          <div class="col-9">
            <span class="option-font option-font-title">{{ configInput[15].desc }}</span>
          </div>
          <div class="col-3 align-r">
            <mat-slide-toggle id="toggle-theme" class="toggle-theme small" [(ngModel)]="showOptions">
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="{{ 'col-' + configInput[16].col }} {{ configInput[16].class }}"
        *ngIf="configInput[16].active && showOptions">
        <app-incremental-input id="input-apparent-quantity" name="model.maxfloor" ondragstart="return false;"
          ondrop="return false;" [placeholder]="configInput[16].desc" [roundLot]="model.loteDefault" minValue="0"
          maxValue="999999" minlength="0" [maxlength]="7" [isQuantity]="true" [(ngModel)]="model.maxfloor"
          aria-required="" [isDisabled]="!quantityDisabled() || !model.quote" (keyup)="validPrice(model.maxfloor)">
        </app-incremental-input>
      </div>
      <div class="{{ 'col-' + configInput[17].col }} {{ configInput[17].class }}"
        *ngIf="configInput[17].active && showOptions">
        <app-incremental-input id="input-min-quantity" [placeholder]="configInput[17].desc"
          [roundLot]="model.loteDefault" [maxlength]="6" (keyup)="validPrice(model.minqtd)" minValue="0" maxValue="999999"
          [isQuantity]="true" [maxlength]="6" [(ngModel)]="model.minqtd" aria-required="" ondragstart="return false;"
          ondrop="return false;" [isDisabled]="!quantityDisabled() || !model.quote">
        </app-incremental-input>
      </div>
      <div class="{{ 'col-' + configInput[18].col }} {{ configInput[18].class }}"
        *ngIf="configInput[18].active && showOptions">
        <mat-form-field>
          <input id="input-observation" matInput [placeholder]="configInput[18].desc" ondragstart="return false;"
            ondrop="return false;" [(ngModel)]="model.orderTag" maxlength="50" [disabled]="!model.quote">
        </mat-form-field>
      </div>
      <div class="{{ 'col-' + configInput[12].col }} {{ configInput[12].class }}" *ngIf="configInput[12].active">
        <div class="row m-btn-5" *ngIf="model.type === 'Market'">
          <div class="{{ 'col-' + subInputs.col }} {{ subInputs.class }}"
            *ngFor="let subInputs of configInput[21].subInputs">
            <span *ngIf="subInputs?.desc">{{ subInputs.desc }}</span>
            <span *ngIf="!subInputs?.desc">
              {{ !messageQuote?.lastTrade ? '-' : indiceFuture ? ( messageQuote?.lastTrade | number:'0.2-2':'pt' ) :
              (messageQuote?.lastTrade) }}
            </span>
          </div>
        </div>
        <div class="row m-btn-5">
          <div class="{{ 'col-' + subInputs.col }} {{ subInputs.class }}"
            *ngFor="let subInputs of configInput[12].subInputs">
            <span *ngIf="subInputs?.desc">{{ subInputs.desc }}</span>
            <span *ngIf="!subInputs?.desc"
              [ngClass]="{'high': listPosition?.currentQuantity > 0, 'low': listPosition?.currentQuantity < 0}">
              {{ listPosition?.currentQuantity ? (listPosition?.currentQuantity | number:'0.2-2':'pt') : '-' }}
            </span>
          </div>
        </div>
        <div class="row m-btn-5">
          <div class="{{ 'col-' + subInputs.col }} {{ subInputs.class }}"
            *ngFor="let subInputs of configInput[13].subInputs">
            <span *ngIf="subInputs?.desc">{{ subInputs.desc }}</span>
            <span *ngIf="!subInputs?.desc"
              [ngClass]="{'high': listPosition?.quantityReleased > 0, 'low': listPosition?.quantityReleased < 0}">
              {{ listPosition?.quantityReleased ? (listPosition?.quantityReleased | number:'0.2-2':'pt') : '-' }}
            </span>
          </div>
        </div>
        <div class="row m-btn-5">
          <div class="{{ 'col-' + subInputs.col }} {{ subInputs.class }}"
            *ngFor="let subInputs of configInput[19].subInputs">
            <span *ngIf="subInputs?.desc">{{ subInputs.desc }}</span>
            <span *ngIf="!subInputs?.desc"
              [ngClass]="{'high': financialAccount?.balanceProjOnline > 0, 'low': financialAccount?.balanceProjOnline < 0}">
              {{ financialAccount.balanceProjOnline ?
              (financialAccount.balanceProjOnline | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
            </span>
          </div>
        </div>
        <div class="row m-btn-5">
          <div class="{{ 'col-' + subInputs.col }} {{ subInputs.class }}"
            *ngFor="let subInputs of configInput[20].subInputs">
            <span *ngIf="subInputs?.desc">{{ subInputs.desc }}</span>
            <span *ngIf="!subInputs?.desc"
              [ngClass]="{'high': financialAccount?.uniqueLimit > 0, 'low': financialAccount?.uniqueLimit < 0}">
              {{ financialAccount.uniqueLimit ?
              (financialAccount.uniqueLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
            </span>
          </div>
        </div>

      </div>
    </div>
    <div class="col-12 p-0 btn" [ngClass]="{'theory': auctionHammer, 'billet-float': isBilletFloat}"
      *ngIf="!loadingBtn">
      <button mat-raised-button color="buy" class="xms" [disabled]="!model.quote || !qtdValid || model.qtd === 0
      || !model.validityOrder || model.validityOrder < minDate2
      || (model.type !== 'Stop' && !checkMarket && (model.price === 0 || model.price === '' || !model.price))
      || ((model.type === 'Stop' || model.type === 'Stop Loss') && model.stopLoss && (!lossTrigger || !lossLimit))
      || ((model.type === 'Stop' && stopGain && (!gainTrigger || !gainLimit)))"
        [ngClass]="{'buy': isBuy, 'sell': !isBuy}" (click)="openModalConfirm()">
        {{ !isBuy ? 'VENDER' : 'COMPRAR' }}
      </button>
    </div>
  </div>
</div>
